<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('studentScoringEntry.advisor')
          }}</label>
          <select class="form-control" v-model="model.advisor_id">
            <option :value="1">{{ $t('studentscoringentry.teacher') }}</option>
            <option :value="2">
              {{ $t('studentscoringentry.management') }}
            </option>
            <option :value="3">{{ $t('studentscoringentry.parent') }}</option>
          </select>
          <div class="validate" v-if="errors.has('advisor_id')">
            {{ errors.first('advisor_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('studentScoringEntry.comment')
          }}</label>
          <ts-button
            outline
            class="ts-ml-6 ts-mb-2 ts-text-xs"
            color="info"
            @click.prevent="onClickComment"
            >{{ $t('studentScoringEntry.clickComment') }}</ts-button
          >
          <VueEditor v-model="model.comments" :editor-toolbar="customToolbar" :disabled="disableComment" 
          :class="{ 'ts-bg-gray-100' : disableComment }"/>
          <p v-if="!isOver()">
            You have {{ charactersRemaining }} characters remaining.
          </p>
          <p v-else class="over ts-text-red-700">
            You are {{ charactersOver }} characters over the limit.
          </p>
          <div class="validate" v-if="errors.has('comments')">
            {{ errors.first('comments') }}
          </div>
        </div>
      </div>
      <a-modal
        v-if="clickComment"
        v-model="clickComment"
        :closable="false"
        width="50%"
        :title="$t('studentScoringEntry.clickComment')"
      >
        <ClickComment v-model="model" :comments="comments"/>
        <template v-slot:footer>
        <ts-button color="primary" @click="() => (clickComment = false)">{{
          $t('ok')
        }}</ts-button>
      </template>
      </a-modal>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { VueEditor } from 'vue2-editor'
import { formViewModel } from '@/api/student-scoring-table-entry'
import ClickComment from './click-comment.vue'
import httpClient from '@/http-client'

export default {
  name: 'studentScoreComment',
  components: { VueEditor, ClickComment },
  props: ['value', 'scoringCycleId', 'cycleValue'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      clickComment: false,
      comments: [],
      model: {},
      maxCharacters: 500,
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }]
      ]
    }
  },
  computed: {
    charactersRemaining: function() {
      return this.maxCharacters - this.model.comments.length
    },
    charactersOver: function() {
      return this.isOver() ? this.model.comments.length - this.maxCharacters : 0
    },
    disableComment(){
      return !this.$store.getters.authPermissionAllow('update-score-comments');
    },
  },
  created() {
    this.model = this.value
    this.fetchComment()
    this.getComment()
  },
  methods: {
    isOver: function() {
      return this.charactersRemaining < 0
    },
    onClickComment() {
      this.clickComment = true
    },
    getComment(){
				this.loading = true
				this.$store
				.dispatch('studentScoringEntry/getComment')
				.then(response => {
					this.loading = false
					this.comments = response.data.map(el => ({
						value: el.comment_id,
						label: el.comment,
						checked: this.model.comments.includes(el.comment)
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
		},
    fetchComment() {
      this.loading = true
      formViewModel({
        params: {
          fnName: 'getComment',
          student_id: this.value.student_id,
          scoring_cycle_id: this.scoringCycleId,
          cycle_value: this.cycleValue,
          st_class_id: this.value.st_class_id
        }
      })
        .then(({ data }) => {
          if (data.getComment) {
            const { advisor_id, comments, sc_stu_com_id } = data.getComment

            if (comments == this.model.comments || this.model.comments == '') {
              this.model.comments = comments
            }
            this.model.advisor_id = advisor_id
            this.model.sc_stu_com_id = sc_stu_com_id
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
